import {buyeeUrl} from "utils/url";

const Page404 = () => {
  window.location.href = buyeeUrl('errors/404');

  return null;
}

export default Page404;
